var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help"},[_c('Promo'),_c('Social'),_c('DialogBox',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h2',[_vm._v("Ayuda")])]},proxy:true},{key:"body",fn:function(){return [_c('VideoSlider')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }